module.exports = __webpack_public_path__ + "img/comp-37.da901878.png";